/**
 * Les PNR du dossier, tels qu'on les montre au voyageur : « ABC123, DEF456 ».
 *
 * Lus sur les voyages, dans leur ordre, en écartant les annulés : un client n'a pas à
 * retrouver le PNR d'un voyage mort dans son numéro de dossier. « NA » est le défaut
 * d'un voyage sans PNR, pas une référence. Repli sur le PNR du dossier puis sur sa
 * référence MV-….
 */
export const bookingPnrLabel = (booking: {
  pnr: null | string
  reference: string
  trips: { cancelledAt: null | string; pnr: string }[]
}): string => {
  const pnrs = [
    ...new Set(
      booking.trips
        .filter((trip) => !trip.cancelledAt && trip.pnr !== '' && trip.pnr !== 'NA')
        .map((trip) => trip.pnr)
    ),
  ]
  return pnrs.join(', ') || booking.pnr || booking.reference
}
